import React from "react";
import {
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input
} from "reactstrap";

import { PictureUpload } from "components";
import Select from "react-select";

class Step3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      postalCode: this.props.wizardData.wizardState.postalCode,
      city: this.props.wizardData.wizardState.city,
      province: this.props.wizardData.wizardState.province,
      email: "",
      comunity: "",
      postalCodeState: "",
      cityState: "",
      provinceState: "",
      comunityState: "",
      emailState: "",
      street: this.props.wizardData.wizardState.street,
      streetState: ""
    };
    console.log("######### wizard data in address #######");
    console.log(this.props.wizardData.wizardState);

    if (this.props.wizardData.wizardState.isCreateFromRequest){
      this.state = {
        postalCodeState: " has-success",
        cityState: " has-success",
        provinceState: " has-success",
        comunityState: " has-danger",
        streetState: " has-success"
      };

      if (this.props.wizardData.wizardState.comunity && this.props.wizardData.wizardState.comunity.length > 2) {
        this.state.comunityState = " has-success";
      }
    }
  }
  postalCodeChange(e) {
    this.setState({
      postalCode: e.target.value
    });
    if (e.target.value.length == 5) {
      this.setState({
        postalCodeState: " has-success"
      });
    } else {
      this.setState({
        postalCodeState: " has-danger"
      });
    }
    this.onChange("postalCode", e.target.value);
  }
  streetChange(e) {
    this.setState({
      street: e.target.value
    });
    if (e.target.value.length > 2) {
      this.setState({
        streetState: " has-success"
      });
    } else {
      this.setState({
        streetState: " has-danger"
      });
    }
    this.onChange("street", e.target.value);
  }
  cityChange(e) {
    this.setState({
      city: e.target.value
    });
    if (e.target.value.length > 2) {
      this.setState({
        cityState: " has-success"
      });
    } else {
      this.setState({
        cityState: " has-danger"
      });
    }
    this.onChange("city", e.target.value);
  }
  provinceChange(e) {
    this.setState({
      province: e.target.value
    });
    if (e.target.value.length > 2) {
      this.setState({
        provinceState: " has-success"
      });
    } else {
      this.setState({
        provinceState: " has-danger"
      });
    }
    this.onChange("province", e.target.value);
  }
  comunityChange(e) {
    this.setState({
      comunity: e.target.value
    });
    if (e.target.value.length > 2) {
      this.setState({
        comunityState: " has-success"
      });
    } else {
      this.setState({
        comunityState: " has-danger"
      });
    }
    this.onChange("comunity", e.target.value);
  }
  emailChange(e) {
    this.setState({
      email: e.target.value
    });
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(e.target.value)) {
      this.setState({
        emailState: " has-success"
      });
    } else {
      this.setState({
        emailState: " has-danger"
      });
    }
    this.onChange("email", e.target.value);
  }
  onChange(field, value) {
    this.props.wizardData.onChange(field, value);
  }
  isValidated() {
    if (
      this.state.postalCodeState !== " has-success" ||
      this.state.cityState !== " has-success" ||
      this.state.streetState !== " has-success" ||
      this.state.provinceState !== " has-success" ||
      this.state.comunityState !== " has-success"
    ) {
      this.setState({
        postalCodeState: " has-danger",
        cityState: " has-danger",
        provinceState: " has-danger",
        comunityState: " has-danger",
        streetState: " has-danger"
      });
      return false;
    }
    return true;
  }
  render() {
    return (
      <div>
        <h5 className="info-text">
          {" "}
          ¿Vive en un lugar bonito?
        </h5>
        <Row className="justify-content-center">
          <Col xs={12} sm="12">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.streetState ? this.state.streetState : "") +
                (this.state.streetFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons business_badge" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.street}
                type="text"
                placeholder="Dirección (Calle, número...)"
                name="street"
                onFocus={e => this.setState({ streetFocus: true })}
                onBlur={e => this.setState({ streetFocus: false })}
                onChange={e => this.streetChange(e)}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.cityState ? this.state.cityState : "") +
                (this.state.cityFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons location_compass-05" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.city}
                type="text"
                placeholder="Localidad"
                name="city"
                onFocus={e => this.setState({ cityFocus: true })}
                onBlur={e => this.setState({ cityFocus: false })}
                onChange={e => this.cityChange(e)}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.postalCodeState ? this.state.postalCodeState : "") +
                (this.state.postalCodeFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons location_pin" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.postalCode}
                type="number"
                placeholder="Código postal"
                name="postalCode"
                onFocus={e => this.setState({ postalCodeFocus: true })}
                onBlur={e => this.setState({ postalCodeFocus: false })}
                onChange={e => this.postalCodeChange(e)}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.provinceState ? this.state.provinceState : "") +
                (this.state.provinceFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons location_map-big" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.province}
                type="text"
                placeholder="Provincia"
                name="province"
                onFocus={e => this.setState({ provinceFocus: true })}
                onBlur={e => this.setState({ provinceFocus: false })}
                onChange={e => this.provinceChange(e)}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.comunityState ? this.state.comunityState : "") +
                (this.state.comunityFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons location_world" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.comunity}
                type="text"
                placeholder="Comunidad Autónoma"
                name="comunity"
                onFocus={e => this.setState({ comunityFocus: true })}
                onBlur={e => this.setState({ comunityFocus: false })}
                onChange={e => this.comunityChange(e)}
              />
            </InputGroup>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Step3;



// WEBPACK FOOTER //
// ./src/views/Customers/CustomerWizard/CustomerAddress.jsx